import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { NotificationService } from "elior-group.joyfood.packages.order-validator";

@Injectable({
    providedIn: 'root',
})
export class NotificationConsumerService {
    constructor(
        private nzNotificationService: NzNotificationService,
        private notificationService: NotificationService,
        private translateService: TranslateService
    ) {
    };
    notificationHandlers: any = {
        warning: {
            MAX_COMPOSITION_LIMIT_REACHED: () =>
                this.nzNotificationService.warning(
                    this.translateService.instant('notifications.maxCompositionLimit.title'),
                    this.translateService.instant('notifications.maxCompositionLimit.message')
                ),

            MAX_CATEGORY_LIMIT_REACHED: (data: any) =>
                this.nzNotificationService.warning(
                    this.translateService.instant('notifications.maxCategoryLimit.title'),
                    this.translateService.instant('notifications.maxCategoryLimit.message', { categoryName: data?.categoryName || this.translateService.instant('notifications.unknownCategory') })
                ),

            INSUFFICIENT_CURRENCY: () =>
                this.nzNotificationService.warning(
                    this.translateService.instant('notifications.insufficientCurrency.title'),
                    this.translateService.instant('notifications.insufficientCurrency.message')
                ),

            MAX_DISH_LIMIT_REACHED: () => this.nzNotificationService.warning(
                this.translateService.instant('notifications.max_dish_limit_reached.title'),
                this.translateService.instant('notifications.max_dish_limit_reached.message')
            ),

            AGREEMENT_DISH_LIMIT_EXCEEDED: () => this.nzNotificationService.warning(
                this.translateService.instant('notifications.agreement_dish_limit_exceeded.title'),
                this.translateService.instant('notifications.agreement_dish_limit_exceeded.message')
            ),
            MAX_SHOP_TRAY_LIMIT_REACHED: () => this.nzNotificationService.warning(
                this.translateService.instant('notifications.max_shop_tray_limit_reached.title'),
                this.translateService.instant('notifications.max_shop_tray_limit_reached.message')
            ),
            NO_VALID_COMPOSITION: () => this.nzNotificationService.warning(
                this.translateService.instant('notifications.no_valid_composition.title'),
                this.translateService.instant('notifications.no_valid_composition.message')
            )
        }


    }
    init() {
        this.notificationService.notifications$.subscribe(notif => {
            const typeHandlers = this.notificationHandlers[notif.payload.type] || {};
            const handler = typeHandlers[notif.eventName] || typeHandlers.default;

            if (handler) {
                handler(notif.payload.data);
            } else {
                console.warn("Unknown notification type or event", notif);
            }
        });
    }
}